import { TenantEntity } from '../TenantEntity'
import { DataSyncBase } from '@/class/model/DataSyncBase'

export class PriceChargingItem extends DataSyncBase {
  constructor(data) {
    super(data)
    this.className = 'PriceChargingItem'
  }

  get priceUuid() {
    return this._data.priceUuid
  }

  set priceUuid(priceUuid) {
    this._data.priceUuid = priceUuid || ''
  }

  get qutChargingItemUuid() {
    return this._data.qutChargingItemUuid
  }

  set qutChargingItemUuid(qutChargingItemUuid) {
    this._data.qutChargingItemUuid = qutChargingItemUuid || ''
  }

  get type() {
    return this._data.type
  }

  set type(type) {
    this._data.type = type || 0
  }

  get chargeItemId() {
    return this._data.chargeItemId
  }

  set chargeItemId(chargeItemId) {
    this._data.chargeItemId = chargeItemId || 0
  }

  get currency() {
    return this._data.currency
  }

  set currency(currency) {
    this._data.currency = currency || ''
  }

  get gp20() {
    return this._data.gp20
  }

  set gp20(gp20) {
    this._data.gp20 = gp20 || 0.0
  }

  get hc20() {
    return this._data.hc20
  }

  set hc20(hc20) {
    this._data.hc20 = hc20 || 0.0
  }

  get gp40() {
    return this._data.gp40
  }

  set gp40(gp40) {
    this._data.gp40 = gp40 || 0.0
  }

  get hc40() {
    return this._data.hc40
  }

  set hc40(hc40) {
    this._data.hc40 = hc40 || 0.0
  }

  get hc45() {
    return this._data.hc45
  }

  set hc45(hc45) {
    this._data.hc45 = hc45 || 0.0
  }

  get nor20() {
    return this._data.nor20
  }

  set nor20(nor20) {
    this._data.nor20 = nor20 || 0.0
  }

  get nor40() {
    return this._data.nor40
  }

  set nor40(nor40) {
    this._data.nor40 = nor40 || 0.0
  }

  get remarks() {
    return this._data.remarks
  }

  set remarks(remarks) {
    this._data.remarks = remarks || ''
  }

  get measure() {
    return this._data.measure
  }

  set measure(measure) {
    this._data.measure = measure || ''
  }

  get unitRate() {
    return this._data.unitRate
  }

  set unitRate(unitRate) {
    this._data.unitRate = unitRate || 0.0
  }
}
